import { useRef } from 'react';
import useConfirm from '../useConfirm/useConfirm';

/**
 * useFormModal acts as a wrapper around useConfirm providing a means to inject a form and allow it to interact
 * with useConfirm's submit button and the ultimate resolving of form data.
 * The magic happens via confirmAction which, provided to useConfirm from useFormModal, sets a resolve function
 * from useConfirm to useFormModal and triggers form submission in useFormModal. If the form's validation passes,
 * useFormModal executes the resolve with the data from the form which useConfirm then returns and closes the modal.
 */
const useFormModal = () => {
  const resolverRef = useRef(null);
  const submitRef = useRef(null);

  // Promise used to return data from useFormModal once the form data has been submitted, received, and accepted
  const { promise, resolve: resolveForm, reject: rejectForm } = Promise.withResolvers();

  const onSubmit = (input) => {
    if (resolverRef.current) {
      resolverRef.current();
    }
    resolveForm(input);
  };

  const confirmAction = async (resolver) => {
    // resolverRef resolves the promise from useConfirm which closes the modal
    resolverRef.current = resolver;
    submitRef.current.click();
  };

  const defaultProps = {
    title: '',
    onSubmit,
    submitRef,
    confirmAction,
  };

  const confirm = useConfirm();

  return (props) => {
    confirm({
      ...defaultProps,
      ...props,
      // content: <ModalForm fields={props.fields} defaultValues={props.defaultValues} onSubmit={onSubmit} submitRef={submitRef} />,
      // formComponent: ModalForm,
      Form: props.Form,
      FormProps: {
        ...props.FormProps,
        // fields: props.fields,
        // defaultValues: props.defaultValues,
        onSubmit,
        submitRef,
      }
    }).catch(() => {
      rejectForm();
    });
    return promise;
  };
};

export default useFormModal;
